/* global Modernizr */

var App = App || {};

App.Slides = (function ($) {
	"use strict";

	var $course = $('.slides__viewport'),
		$panels = $course.find('.course__panels'),
		$progress = $course.find('.course__progress'),
		$currentStep = $course.find('.course__steps--current'),
		$totalSteps = $course.find('.course__steps--total'),
		$next = $course.find('.course__nav--next'),
		$prev = $course.find('.course__nav--prev'),
		_totalSteps = $panels.find('.course-panel').length,
		_courseKey;

	function init(courseKey) {
		_courseKey = courseKey;

		App.waitForImagesToLoad('.course__panels')
			.then(setMinHeight);

		$totalSteps.html(_totalSteps);
		App.$window.on('enter-sm enter-md enter-lg enter-xl', setMinHeight);

		$panels.slick({
			arrows: true,
			autoplay: false,
			accessibility: false,
			dots: false,
			draggable: false,
			infinite: false,
			swipe: false,
			adaptiveHeight: true,
			slidesToScroll: 1,
			nextArrow: $next,
			prevArrow: $prev
		});

		$panels.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			var bp = ZAGFramework.GetCurrentBP();
			setProgress(nextSlide);

			if (bp === 'sm' || bp === 'md') {
				scrollToTop();
			}

			$('.embed-responsive-item').each(function () {
				var el_src = $(this).attr("src");
				$(this).attr("src", el_src);
			});
		});

		getUserCourse(_courseKey).done(function (response, textStatus, jqXHR) {
			if (!response) {
				console.log("API did not respond.");
				return;
			}

			if (response.success) {
				$panels.slick("slickGoTo", response.data.slideIndex, false);
				return
			}

			$panels.slick("slickGoTo", 0, false);
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.error("Request failed:", textStatus, errorThrown);
		});
	}

	function setProgress(index) {
		$.ajax({
			cache: false,
			url: `/api/courses/${_courseKey}/set_progress/${index}`,
			type: "GET",
			dataType: "json"
		}).done(function (response, textStatus, jqXHR) {
			if (!response) {
				console.log("API did not respond.");
				return;
			}

			if (response.success) {
				$currentStep.html(index + 1);
				$prev.toggle(index > 0);
				$next.toggle(index < _totalSteps - 1);
				$progress.stop().animate({ 'width': (100 * ((index + 1) / _totalSteps)) + '%' });
				return;
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.error("Request failed:", textStatus, errorThrown);
		});
	}


	function scrollToTop() {
		$('html,body').animate({ scrollTop: $course.offset().top }, 500);
	}

	function getUserCourse(key) {
		return $.ajax({
			cache: false,
			url: `/api/courses/${key}`,
			type: "GET",
			dataType: "json"
		});
	}

	function setMinHeight() {
		var minHeight = 0,
			bp = ZAGFramework.GetCurrentBP();

		if (["lg", "xl", "xxl"].includes(bp)) {
			$panels.find('.course-panel').each(function () {
				var h = $(this).height();
				minHeight = minHeight > h ? minHeight : h;
			});
		}

		$panels.find('.course-panel').css('min-height', minHeight);
	}

	function moveNext() {
		$panels.slick("slickNext");
	}

	function movePrevious() {
		$panels.slick("slickPrev");
	}

	return {
		init: init,
		moveNext: moveNext,
		movePrevious: movePrevious
	};
})(jQuery);

